module.exports = __webpack_public_path__ + "img/login-bg.92da5a59.jpg";